import { defineMessages } from 'react-intl'

import { AppError } from '@app/errors/AppError'

import { createSelector } from '@app/utils/createSelector'
import moment from '@app/utils/moment'

import type { ApiAffiliate } from '@app/packages/api/v2/types/entities'
import { createPromise } from '@app/packages/thunkSelector/promiseState'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'

import { callV2Api } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'

import { routingDateSelector } from './routing'

const affiliatesSlice = createReduxSlice<{ loaded_at: string; list: ApiAffiliate[] }>('affiliates')

export const affiliatesResultSelector = createSelector([affiliatesSlice.selector, routingDateSelector], (slice, date) =>
  createLoadable(c => {
    if (!slice || moment(slice.loaded_at).add(30, 'minutes').isBefore(date)) {
      const loadedAt = date.format()
      return c.load(
        createPromise('Links must be fetched', loadedAt, async dispatch => {
          const [{ getAffiliates }, { getIntl }] = await Promise.all([import('@app/packages/api/v2/actions/affiliates'), import('@app/store/actions/initial')])
          const { formatMessage } = dispatch(getIntl())
          const resp = await dispatch(callV2Api(getAffiliates())).catch(e => {
            throw new AppError('Affiliates fetch failed')
              .withCause(e)
              .withExpose(true)
              .withHandled(true)
              .withLocalizedMessage(formatMessage(messages['Affiliates fetch failed']))
          })
          dispatch(affiliatesSlice.set({ loaded_at: loadedAt, list: resp.data }))
        })
      )
    }
    return slice.list
  })
)

const messages = defineMessages({
  'Affiliates fetch failed': { id: "store.slices.affiliates.messages.Affiliates fetch failed.12a4", defaultMessage: 'Не удалось получить список аффилиатов' },
})
